import type { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { AppLayout } from './components/layout/AppLayout';
import { HomePage } from './pages/HomePage';
import { HealthPage } from './pages/HealthPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { WebmailPage } from './pages/WebmailPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { BillingPage } from './pages/BillingPage';
import { ApiKeysPage } from './pages/ApiKeysPage';
import { AdminPage } from './pages/AdminPage';

export const App: FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Auth Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Authenticated Application Shell */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              <Route path="webmail" element={<WebmailPage />} />
              <Route path="campaigns" element={<CampaignsPage />} />
              <Route path="billing" element={<BillingPage />} />
              <Route path="api-keys" element={<ApiKeysPage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route path="health" element={<HealthPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
